"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("/opt/jenkins/workspace/sit-app-client/node_modules/core-js/modules/es6.array.iterator.js");

require("/opt/jenkins/workspace/sit-app-client/node_modules/core-js/modules/es6.promise.js");

require("/opt/jenkins/workspace/sit-app-client/node_modules/core-js/modules/es6.object.assign.js");

require("/opt/jenkins/workspace/sit-app-client/node_modules/core-js/modules/es7.promise.finally.js");

var _vue = _interopRequireDefault(require("vue"));

require("./vant-ui");

var _App = _interopRequireDefault(require("./App"));

var _router = _interopRequireDefault(require("./router"));

require("./css/reset.css");

require("./css/common.css");

var _imgPreview = _interopRequireDefault(require("./components/img-preview"));

var _qtBridge = _interopRequireDefault(require("@/plugins/qt/qt-bridge"));

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 引入reset.css和common.css
_vue.default.use(_imgPreview.default);

_vue.default.use(_qtBridge.default);

_vue.default.config.productionTip = false;
/* eslint-disable no-new */

new _vue.default({
  el: '#app',
  router: _router.default,
  components: {
    App: _App.default
  },
  template: '<App/>'
});